import {isNotNil} from 'ramda';

import type {CustomerInsightsBusinessCaseRecord} from '../types/CustomerInsightsViewModel';

export interface CustomerInsightsBusinessCasePriceSource {
  offers: ReadonlyArray<{
    offerTotalPrice?: {
      withVat?: {amount: number | string; currency: string} | null;
    } | null;
  }>;
}

export function getCustomerInsightsBusinessCasePrice(
  businessCase: CustomerInsightsBusinessCasePriceSource | undefined
): CustomerInsightsBusinessCaseRecord['price'] {
  const priceWithVat = businessCase?.offers[0]?.offerTotalPrice?.withVat;
  const amount = Number(priceWithVat?.amount);

  return isNotNil(priceWithVat) && Number.isFinite(amount)
    ? {amount, currency: priceWithVat.currency}
    : undefined;
}
